import {urlBuilder} from "@torim-app/utils";

const serverHost = `${import.meta.env.VITE_BACKEND_URL}`

export const adminUrlBuilder = (
  queryParams: Record<string, string | number | boolean>,
  path = ''
): string => {
  return urlBuilder(`${serverHost}/manage`, queryParams, path);
}

export const clientUrlBuilder = (
  queryParams: Record<string, string | number | boolean>,
  path = ''
): string => {
  return urlBuilder(`${serverHost}/client`, queryParams, path);
}

export const customerAppUrlBuilder = (
  queryParams: Record<string, string | number | boolean>,
  path = ''
): string => {
  return urlBuilder(`${serverHost}/customer-app`, queryParams, path);
}

export const platformUrlBuilder = (
  queryParams: Record<string, string | number | boolean>,
  path = ''
): string => {
  return urlBuilder(`${serverHost}/platform`, queryParams, path);
}
